// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"59d849a8","796":"59d849a8"}[chunkId] + ".chunk.css";
};